import React, { useEffect, useState, useRef } from "react";
import {
  UserOutlined,
  VideoCameraOutlined,
  MoonOutlined,
  SunOutlined,
  HomeOutlined,
  NotificationOutlined,
  AppstoreOutlined,
  SettingOutlined,
  MessageOutlined,
  CalendarOutlined,
  FileTextOutlined,
  CoffeeOutlined,
  SearchOutlined,
  DownOutlined,
  LogoutOutlined,
  ExceptionOutlined,
  CloseOutlined
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Button,
  theme,
  Space,
  Badge,
  Avatar,
  Dropdown,
  Breadcrumb,
  Flex,
  Drawer,
  Form,
  Input,
  Select,
  Switch,
  Tag,
  Typography,
  Pagination,
  Empty,
  Tooltip,
  notification
} from "antd";
import Logo from "../assets/image/logo/Octaplex Logo.png";
import Empty_profile_pic from "../assets/image/empty_profile_pic.png";
import { SIZES } from "../theme/constant";
import { useSelector, useDispatch } from "react-redux";
import { loginCompany, logout } from "../redux/slices/authSlice";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import UserProfileAPI from "../restAPI/UserProfileAPI";
import AuthRestAPI from "../restAPI/AuthRestAPI";
import DocumentSearchAPI from "../restAPI/DocumentSearchAPI";
import AnnotationAPI from "../restAPI/AnnotationAPI";
import AnnotationModal from "../components/AnnotationModal";
import moment from "moment";
import { setProfileDataUpdate } from "../redux/slices/profileSlice";
import CommonSkeletonLoader from "../helperComponents/CommonSkeleton";
// import socket from "../socketService";
import { connectNotificationSocket, getNotificationSocket } from '../notificationSocketService';
import { addNotification, clearNotifications, removeNotification, setNotificationCount, setNotifications } from "../redux/slices/notificationSlice";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Middleware, { MiddlewareClass } from "../restAPI/Middleware";

dayjs.extend(relativeTime);


const { Header, Sider, Content } = Layout;
const { Text } = Typography;
const { Search } = Input;

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const MainLayout = ({ toggleTheme, getTheme }) => {
  const navigate = useNavigate();
  const count = useSelector((state) => state.notification.count);
  const notifications = useSelector((state) => state.notification.notifications);
  const { companyId, userCompany, token } = useSelector((state) => state.auth);
  const { profileUpdated } = useSelector((state) => state.profileDetails);
  const [navSelected, setNavSelected] = useState("");
  const [openKeys, setOpenKeys] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const location = useLocation();
  const [items2, setItems2] = useState([]);
  const initialized = useRef(false);
  const dispatch = useDispatch();
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [currentCompanyInfo, setCurrentCompanyInfo] = useState({});
  const [pagination, setPagination] = useState(1);
  const [payload, setPayload] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [totalResults, setTotalResults] = useState(0);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [annotationModalVisible, setAnnotationModalVisible] = useState(false);
  const [currentAnnotationUrl, setCurrentAnnotationUrl] = useState(null);
  const [currentAnnotationTitle, setCurrentAnnotationTitle] = useState("PDF Annotation");

  const isMenuClick = useRef(false);
  const isFirstMount = useRef(true);
  const previousPathname = useRef(location.pathname);
  const [open, setOpen] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [documentSearchMessage, setDocumentSearchMessage] = useState(null);
  const [documentSearchTitle, setDocumentSearchTitle] = useState(null);
  const [api, contextHolder] = notification.useNotification();


  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
    });
  };




  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setSearchText("");
    setPayload([]);
    setOpen(false);
    setTotalResults(0);
  };

  const showNotificationDrawer = () => {
    const existingSocket = getNotificationSocket();
    if (!existingSocket?.connected) return;

    const allNotificationIds = notifications.map((n) => n.id);
    if (allNotificationIds.length > 0) {
      existingSocket.emit('notification_read', allNotificationIds);
    }
    setOpenNotification(true); // Only open when user clicks
  };

  const clearAllNotifications = () => {
    const existingSocket = getNotificationSocket();
    if (!existingSocket?.connected) return;

    const allNotificationIds = notifications.map((n) => n.id);
    if (allNotificationIds.length > 0) {
      existingSocket.emit('notification_clear', allNotificationIds);
    }

    dispatch(clearNotifications()); // Clear from Redux
    dispatch(setNotificationCount(0)); // Reset count to 0
    // setOpenNotification(false);
  };

  const closeNotificationDrawer = () => {
    setOpenNotification(false); // Close the drawer
  };

  const [items, setItems] = useState([
    {
      key: "1",
      label: <a href="#">Hi there</a>,
      icon: <UserOutlined />,
    },
    {
      key: "2",
      label: (
        <div onClick={showNotificationDrawer}>
          <span style={{ marginRight: SIZES.medium }}>Notification</span>
          {/* <Badge count={count} /> */}
        </div>
      ),
      icon: <NotificationOutlined />,
    },
    {
      key: "3",
      label: (
        <div>
          <span style={{ marginRight: SIZES.medium }}>Mode</span>
          <Space direction="vertical">
            <Switch
              unCheckedChildren={<SunOutlined />}
              checkedChildren={<MoonOutlined />}
              checked={!(getTheme === "default")}
              onChange={toggleTheme}
            />
          </Space>
        </div>
      ),
    },
    {
      key: "4",
      danger: true,
      label: "Logout",
      icon: <LogoutOutlined />,
    },
  ]);

  const documentSearchStatus = [
    {
      title: "Search Documents",
      message: "Enter a keyword or phrase to begin your search."
    },
    {
      title: "No Results Found",
      message: "No documents match your search. Try another keyword."
    },
    {
      title: "Something Went Wrong",
      message: "Please try again later."
    },
    {
      title: "No Internet Connection",
      message: "Check your connection and try again."
    },
  ];

  useEffect(() => {
    if (open) {
      setDocumentSearchTitle(documentSearchStatus[0].title);
      setDocumentSearchMessage(documentSearchStatus[0].message);
    }
  }, [open]);

  useEffect(() => {
    const existingSocket = getNotificationSocket();
    if (existingSocket?.connected) return;

    if (token && companyId) {
      const socket = connectNotificationSocket(token, companyId);

      socket.on('connect', () => {
        socket.emit('notification_join');

        // Wait for count first
        socket.on('notification_count', (count) => {
          dispatch(setNotificationCount(count));
        });

        // Then fetch all notifications
        socket.emit('notification_fetch');

        socket.on('notification_all', (notifications) => {
          dispatch(setNotifications(notifications));
        });
      });

      socket.on('notification_new', (notification) => {
        dispatch(addNotification(notification));
      });

      socket.on('notification_error', (error) => {
        console.error("Notification Error:", error);
      });

      socket.on('user_inactive', async () => {
        socket.disconnect();

        try {
          await AuthRestAPI.logout(companyId, token);
        } catch (_) {
          // Ignore logout API errors and continue local logout.
        }

        dispatch(logout());
        navigate("/login");
      });

      return () => {
        const existingSocket = getNotificationSocket();
        if (existingSocket?.connected) {
          existingSocket.disconnect();
        }
      };
    }
  }, [token, companyId, dispatch]);

  useEffect(() => {
    // Optional: update some internal state or context
    // to force the sidebar to update highlighting
  }, [location]);

  useEffect(() => {
    const currentPath = location.pathname;
    let selectedKey = "";
    let parentKey = "";

    const findKeys = (items) => {
      for (const item of items) {
        if (item.children) {
          for (const child of item.children) {
            if (currentPath === child.key || currentPath.endsWith(child.key)) {
              selectedKey = child.key;
              parentKey = item.key;
              return true;
            }
          }
        } else if (currentPath === item.key || currentPath.endsWith(item.key)) {
          selectedKey = item.key;
          return true;
        }
      }
      return false;
    };

    findKeys(items2);

    if (currentPath === "/MasterData/bulk-upload") {
      selectedKey = "/MasterData";
    } else {
      findKeys(items2);
      if (!selectedKey) {
        selectedKey = "/Home";
      }
    }
    setNavSelected(selectedKey);

    // Only update openKeys if it's not a direct menu click
    // Skip submenu logic if it's first mount or path hasn't changed
    if (!isMenuClick.current) {
      if (isFirstMount.current || previousPathname.current === currentPath) {
        isFirstMount.current = false;
        previousPathname.current = currentPath;
        return;
      }

      // Run submenu open/close logic only if path is actually different
      if (parentKey && !openKeys.includes(parentKey)) {
        setOpenKeys([parentKey]);
      } else if (!parentKey && openKeys.length > 0) {
        setOpenKeys([]);
      }
    }

    previousPathname.current = currentPath;
    isFirstMount.current = false;

    // Reset the flag after the useEffect runs
    // isMenuClick.current = false;
  }, [location.pathname, items2]);

  useEffect(() => {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.key === "3"
          ? {
            ...item,
            label: (
              <div>
                <span style={{ marginRight: SIZES.medium }}>Mode</span>
                <Space direction="vertical">
                  <Switch
                    unCheckedChildren={<SunOutlined />}
                    checkedChildren={<MoonOutlined />}
                    checked={!(getTheme === "default")}
                    onChange={toggleTheme}
                  />
                </Space>
              </div>
            ),
          }
          : item
      )
    );
  }, [getTheme]);

  useEffect(() => {
    const formattedCompanyData =
      userCompany?.companyData &&
      userCompany?.companyData.map((company) => ({
        value: company?.companyId,
        label: (
          <Badge
            color={`${company?.themeColor || "yellow"}`}
            text={`${company?.companyName}`}
          />
        ),
        disabled: !company.status,
      }));

    setCompanyList(formattedCompanyData);
    setPagination(1);
  }, [userCompany]);

  useEffect(() => {
    if (profileUpdated) {
      const companyInfo = userCompany.companyData.find(
        (company) => company.companyId === companyId
      );
      getProfileData(companyInfo);
    }
  }, [profileUpdated]);

  useEffect(() => {
    if (companyId) {
      if (!initialized.current) {
        initialized.current = true;
        const companyInfo = userCompany.companyData.find(
          (company) => company.companyId === parseInt(companyId)
        );
        setCurrentCompanyInfo(companyInfo);
        getProfileData(companyInfo);
      }
    }
  }, [companyId]);

  useEffect(() => {
    if (companyId) {
      const companyInfo = userCompany.companyData.find(
        (company) => company.companyId === parseInt(companyId)
      );
      console.log("Company Info on companyId/profile update:", companyInfo);
      getProfileData(companyInfo);
      setSelectedRoles(companyInfo.roles);
    }
  }, [companyId, profileUpdated]);

  const [fileList, setFileList] = useState([
    {
      uid: "-1",
      name: "image.png",
      status: "done",
      url: "",
    },
  ]);

  const {
    token: {
      colorBorder,
      colorBgContainer,
      borderRadiusLG,
      colorBgLayout,
      colorBgBase,
      colorNoContainer,
      colorBorderSecondary
    },
    colorPrimary,
  } = theme.useToken();

  const onClick = async ({ key }) => {
    switch (key) {
      case "3":
        toggleTheme();
        break;
      case "4":
        const existingSocket = getNotificationSocket();
        if (existingSocket?.connected) {
          existingSocket.disconnect();
        }

        try {
          await AuthRestAPI.logout(companyId, token);
        } catch (_) {
          // Ignore logout API errors and continue local logout.
        }

        dispatch(logout());
        navigate("/login");
        setDropdownVisible(false);
        break;
      default:
        setDropdownVisible(false);
        break;
    }
  };

  const handleVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  const getProfileData = async (companyInfo) => {
    await UserProfileAPI.getUserProfileByUserDetailsId(
      companyInfo?.userDetailsId,
      parseInt(companyId),
      token
    )
      .then((res) => {
        if (res?.data) {
          setFileList([{ url: res.data.profilePicture }]);
          setItems((prevItems) =>
            prevItems.map((item) =>
              item.key === "1"
                ? {
                  ...item,
                  label: <a href="#">{res?.data?.name}</a>,
                }
                : item
            )
          );
          if (profileUpdated) {
            dispatch(setProfileDataUpdate(false));
          }
        }
      })
      .catch((err) => {
        dispatch(setProfileDataUpdate(false));
        console.log("error getting esignature data :", err.message);
      });
  };

  const handleChangeCompanySelect = (value) => {
    const selectedCompany = userCompany.companyData.find(
      (company) => company.companyId === Number(value)
    );
    const roles = selectedCompany?.roles || [];
    const payload = {
      companyId: value,
      role: roles,
      userDetailsId: selectedCompany?.userDetailsId,
    };
    dispatch(loginCompany(payload));
  };

  const menuHandler = (value) => {
    const selectedKey = value.keyPath[0];
    setNavSelected(selectedKey);

    // Handle both top-level and nested routes correctly
    if (value.keyPath[1]) {
      // Nested route: parent + child
      navigate(`${value.keyPath[1]}${selectedKey}`);
    } else {
      // Top-level route: just the key
      navigate(selectedKey);
    }

    isMenuClick.current = true; // Set the flag
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys); // Manually control open state when user expands/collapses
  };

  useEffect(() => {
    setItems2([]);

    let listPayload = [getItem("Home", "/Home", <HomeOutlined />)];

    let MasterDataList = [];
    let MeetingList = [];
    let ReportsList = [
      getItem("Activity Log Report", "/activity-report"),
    ];
    let WorkflowList = [];

    const addItem = (list, item) => {
      if (!list.some((existingItem) => existingItem.key === item.key)) {
        list.push(item);
      }
    };

    if (selectedRoles.length > 0) {
      selectedRoles.forEach((value) => {
        if (value.restricted) {
          switch (value.roleName) {
            case "Company Admin":
              addItem(MasterDataList, getItem("Branch", "/Branch"));
              addItem(MasterDataList, getItem("Department", "/Department"));
              addItem(MasterDataList, getItem("Role", "/Role"));
              addItem(MasterDataList, getItem("User", "/User"));
              addItem(
                MasterDataList,
                getItem("Committee Type", "/Committee-config")
              );
              addItem(
                MeetingList,
                getItem("Manage Committee", "/Manage-committee")
              );
              addItem(MeetingList, getItem("Meetings", "/Meetings"));

              addItem(
                WorkflowList,
                getItem("Request an Approval", "/request-approval")
              );
              addItem(WorkflowList, getItem("Circulations", "/circuler"));
              addItem(
                WorkflowList,
                getItem("Template Manager", "/template-manager")
              );
              addItem(
                WorkflowList,
                getItem("Workflow Manager", "/workflow-manager")
              );
              addItem(
                WorkflowList,
                getItem("Request Type Manager", "/request-type")
              );
              break;
            case "Admin":
              addItem(MasterDataList, getItem("Branch", "/Branch"));
              addItem(MasterDataList, getItem("Department", "/Department"));
              addItem(MasterDataList, getItem("Role", "/Role"));
              addItem(MasterDataList, getItem("User", "/User"));
              addItem(MasterDataList, getItem("Committee Type", "/Committee-config"));
              addItem(MeetingList, getItem("Manage Committee", "/Manage-committee"));
              addItem(MeetingList, getItem("Meetings", "/Meetings"));
              break;

            case "Secretary":
              // addItem(MasterDataList, getItem('Committee Type', '/Committee-config'));
              addItem(
                MeetingList,
                getItem("Manage Committee", "/Manage-committee")
              );
              addItem(MeetingList, getItem("Meetings", "/Meetings"));
              addItem(
                WorkflowList,
                getItem("Request an Approval", "/request-approval")
              );
              addItem(WorkflowList, getItem("Circulations", "/circuler"));
              addItem(
                WorkflowList,
                getItem("Template Manager", "/template-manager")
              );
              addItem(
                WorkflowList,
                getItem("Workflow Manager", "/workflow-manager")
              );
              addItem(ReportsList, getItem("Meeting Documents Approval Report", "/meeting-docs-report"));
              break;

            case "Assistant Secretary":
              addItem(
                MeetingList,
                getItem("Manage Committee", "/Manage-committee")
              );
              addItem(MeetingList, getItem("Meetings", "/Meetings"));

              /////// Need to Remove
              addItem(
                WorkflowList,
                getItem("Request an Approval", "/request-approval")
              );
              addItem(WorkflowList, getItem("Circulations", "/circuler"));
              addItem(
                WorkflowList,
                getItem("Template Manager", "/template-manager")
              );
              addItem(
                WorkflowList,
                getItem("Workflow Manager", "/workflow-manager")
              );
              addItem(ReportsList, getItem("Meeting Documents Approval Report", "/meeting-docs-report"));
              break;
            case "Director":
            case "General User":
              addItem(MeetingList, getItem("Meetings", "/Meetings"));

              /////// Need to Remove
              addItem(
                WorkflowList,
                getItem("Request an Approval", "/request-approval")
              );
              addItem(WorkflowList, getItem("Circulations", "/circuler"));
              addItem(
                WorkflowList,
                getItem("Template Manager", "/template-manager")
              );
              addItem(
                WorkflowList,
                getItem("Workflow Manager", "/workflow-manager")
              );
              break;
            case "Audit User":
              addItem(MeetingList, getItem("Meetings", "/Meetings"));

              addItem(
                WorkflowList,
                getItem("Request an Approval", "/request-approval")
              );
              addItem(WorkflowList, getItem("Circulations", "/circuler"));
              addItem(
                WorkflowList,
                getItem("Template Manager", "/template-manager")
              );
              addItem(
                WorkflowList,
                getItem("Workflow Manager", "/workflow-manager")
              );
              break;
          }

          // removed because of lates changes came from DFCC bank side
          // and after the discussion with Nuwan Nanayakkara

          // addItem(MeetingList,
          //   getItem("Alternative Signatory", "/Alt-signatory")
          // );
        } else if (value?.permissions) {
          value.permissions.forEach((data) => {
            switch (data.permissionName) {
              case "Branch":
                addItem(MasterDataList, getItem("Branch", "/Branch"));
                break;
              case "Department":
                addItem(MasterDataList, getItem("Department", "/Department"));
                break;
              case "Role":
                addItem(MasterDataList, getItem("Role", "/Role"));
                break;
              case "User":
                addItem(MasterDataList, getItem("User", "/User"));
                break;
              case "Committee Type":
                addItem(
                  MasterDataList,
                  getItem("Committee Type", "/Committee-config")
                );
                break;
            }
            addItem(MeetingList, getItem("Meetings", "/Meetings"));
            // removed because of lates changes came from DFCC bank side
            // and after the discussion with Nuwan Nanayakkara

            // addItem(MeetingList,
            //   getItem("Alternative Signatory", "/Alt-signatory")
            // );
            // Workflow routes for custom user roles
            addItem(
              WorkflowList,
              getItem("Request an Approval", "/request-approval")
            );
            addItem(WorkflowList, getItem("Circulations", "/circuler"));
            addItem(
              WorkflowList,
              getItem("Template Manager", "/template-manager")
            );
            addItem(
              WorkflowList,
              getItem("Workflow Manager", "/workflow-manager")
            );
          });
        }
      });
    }

    if (MasterDataList.length > 0) {
      listPayload.push(
        { type: "divider" },
        getItem(
          "Master Data",
          "/MasterData",
          <AppstoreOutlined />,
          MasterDataList
        )
      );
    }

    if (MeetingList.length > 0) {
      listPayload.push(
        { type: "divider" },
        getItem(
          "Meeting Config",
          "/Meeting-Management",
          <VideoCameraOutlined />,
          MeetingList
        )
      );
    }

    // if (WorkflowList.length > 0) {
    //   listPayload.push(
    //     { type: "divider" },
    //     getItem("Workflow", "/work-flow", <FileWordOutlined />, WorkflowList)
    //   );
    // }

    listPayload.push(
      // { type: "divider" },
      // getItem("Leave Management", "/Leave-Management/Leave-Management", <ExceptionOutlined />),
      { type: "divider" },
      getItem("Calendar", "/My-calendar", <CalendarOutlined />),
      { type: "divider" },
      getItem("Chat", "/chat", <MessageOutlined />),
      { type: "divider" },
      getItem("Reports", "/Reports", <FileTextOutlined />, ReportsList),
      { type: "divider" },
      getItem("Settings", "/Settings", <SettingOutlined />)
    );

    setItems2(listPayload);
  }, [selectedRoles]);

  const onSearchHandler = async (searchText) => {
    setPagination(1);
    if (searchText !== "") {
      setDocumentsLoading(true);
      getSearchAttachments(searchText, 1);
    } else {
      setPayload([]);
    }
    setSearchText(searchText);
  };

  const paginationOnChangehHandler = async (page) => {
    setPagination(page);
    onSearchHandlerWithPagination(searchText, page);
  };

  const onSearchHandlerWithPagination = async (searchText, page) => {
    setDocumentsLoading(true);
    getSearchAttachments(searchText, page);
  };

  const searchTextonChange = async (searchText) => {
    setSearchText(searchText);
    if (searchText.trim() == "") {
      setPayload([]);
      setTotalResults(0);
      setDocumentSearchTitle(documentSearchStatus[0].title);
      setDocumentSearchMessage(documentSearchStatus[0].message);
    }
    // getSearchAttachments(searchText, pagination);
  };

  const getSearchAttachments = async (searchText, page) => {
    // setDocumentsLoading(true);
    const size = 10;
    await DocumentSearchAPI.getSearchAttachments(
      searchText,
      page,
      size,
      companyId,
      token
    )
      .then((res) => {
        if (res?.data) {
          const backendResults = Array.isArray(res.data.result) ? res.data.result : [];

          const normalizedSearch = String(searchText || '').trim().toLowerCase();

          const filteredResults = normalizedSearch
            ? backendResults.filter(rv => {
              const name = rv?.agenda?.category?.item?.attachment?.name || '';
              return name.toLowerCase().includes(normalizedSearch);
            })
            : backendResults;

          const rows = filteredResults.map((rowValue) => {
            const attachment = rowValue?.agenda?.category?.item?.attachment || {};
            const timestamp = attachment.timestamp;

            return {
              documentName: attachment.name || '',
              date: timestamp ? moment(timestamp).format('LL') : '',
              time: timestamp ? moment(timestamp).format('LT') : '',
              categoryName: rowValue?.agenda?.category?.name || '',
              itemCode: rowValue?.agenda?.category?.item?.code || '',
              filePath: attachment.filePath || '',
            };
          });

          if (rows.length === 0) {
            setDocumentSearchMessage(documentSearchStatus[1].message);
            setDocumentSearchTitle(documentSearchStatus[1].title);
          } else {
            setDocumentSearchMessage(null);
            setDocumentSearchTitle(documentSearchStatus[0].title);
          }

          setPayload(rows);
          setTotalResults(rows.length);
          setDocumentsLoading(false);
        }
      })
      .catch((err) => {
        if (err.code == "ERR_NETWORK" || err.message == "Network Error") {
          setDocumentSearchMessage(documentSearchStatus[3].message);
          setDocumentSearchTitle(documentSearchStatus[3].title);
        } else {
          setDocumentSearchMessage(documentSearchStatus[2].message);
          setDocumentSearchTitle(documentSearchStatus[2].title);
        }
        setPayload([]);
        setTotalResults(0);
        setDocumentsLoading(false);
        console.log("error getting documents :", err.message);
      });
  };

  const menuItems = companyList.map((company) => ({
    key: company.value, // Assuming companyList has { value, label } structure
    label: company.label,
  }));

  // Handle menu item click
  const handleMenuClick = ({ key }) => {
    handleChangeCompanySelect(key); // Call the provided function with the selected key
  };
  // Create the dropdown menu
  const menu = (
    <Menu
      items={menuItems}
      onClick={handleMenuClick}
      style={{ minWidth: "ch", width: "fit-content", maxWidth: "100%" }}
    />
  );

  // const handlePDFAnnotation = (doc) => {
  //   // Check if annotation system is enabled
  //   if (!AnnotationAPI.isEnabled()) {
  //     // Show a simple alert since we don't have access to notification system here
  //     alert('PDF annotation is not available.');
  //     return;
  //   }

  //   let annotationUrl = null;

  //   // Check if this is an annotation URL (starts with http)
  //   if (doc.filePath && doc.filePath.startsWith('http')) {
  //     // This is already an annotation URL
  //     annotationUrl = doc.filePath;
  //     console.log('Opening annotation URL in modal:', annotationUrl);
  //   }
  //   // For local files, we need to upload to annotation system first
  //   else {
  //     // This should not happen in normal flow since files are uploaded to annotation system first
  //     alert('This file is not available for annotation.');
  //     return;
  //   }

  //   // Open annotation in modal instead of new window
  //   if (annotationUrl) {
  //     setCurrentAnnotationUrl(annotationUrl);
  //     setAnnotationModalVisible(true);
  //   }
  // };

  const handlePDFAnnotation = (doc) => {
    // Check if annotation system is enabled
    if (!AnnotationAPI.isEnabled()) {
      // Show a simple alert since we don't have access to notification system here
      // alert('PDF annotation is not available.');
      openNotificationWithIcon('warning', 'Annotation System Disabled', 'PDF annotation is not available.', 'bottomLeft');
      return;
    }

    let annotationUrl = null;

    // Check if this is an annotation URL (starts with http)
    if (doc.filePath && doc.filePath.startsWith('/pdf/session/')) {
      // This is already an annotation URL
      const annotationFrontendUrl = AnnotationAPI.getFrontendUrl();
      annotationUrl = `${annotationFrontendUrl}${doc.filePath}`;
      console.log('Opening annotation URL in modal:', annotationUrl);
    }
    // Check if this is already a full annotation URL (starts with http)
    else if (doc.file && (doc.file.startsWith('http://') || doc.file.startsWith('https://'))) {
      // This is already a full annotation URL
      annotationUrl = doc.file;
      console.log('Opening full annotation URL in modal:', annotationUrl);
    }
    // For local files, we need to upload to annotation system first
    else {
      // This should not happen in normal flow since files are uploaded to annotation system first
      openNotificationWithIcon('error', 'Annotation Error', 'This file is not available for annotation.', 'bottomLeft');
      return;
    }

    // Open annotation in modal instead of new window
    if (annotationUrl) {
      setCurrentAnnotationUrl(annotationUrl);
      setCurrentAnnotationTitle(doc.documentName || doc.name || doc.fileName || "PDF Annotation");
      setAnnotationModalVisible(true);
    }
  };

  const handleNotificationClose = (notificationId) => {
    const existingSocket = getNotificationSocket();
    existingSocket.emit('notification_clear', [notificationId]);
    dispatch(removeNotification(notificationId));
  };

  return (
    <Layout style={{ height: "100svh", overflowY: "auto" }}>
      {
        contextHolder
      }
      <Sider trigger={null} collapsible collapsed={true}>
        <Menu
          mode="inline"
          selectedKeys={[navSelected]} // Controlled selected key
          openKeys={openKeys} // Controlled open keys for submenus
          onOpenChange={onOpenChange} // Handle manual open/close
          items={items2}
          style={{
            height: "100vh",
            padding: "0 10px",
            overflowY: "auto",
            alignContent: "center",
          }}
          onClick={menuHandler}
        />
      </Sider>
      {/* Bug 9801 */}
      <Flex vertical={"horizontal"} style={{ width: "calc(100svw - 80px)" }}>
        <Header
          style={{
            paddingLeft: 0,
            paddingRight: 16,
            paddingTop: 32,
            paddingBottom: 16,
            background: colorBgLayout,
            display: "flex",
          }}
        >
          <Flex
            justify="space-between"
            align="center"
            style={{ width: "100%", marginRight: SIZES.small }}
          >
            <Flex align="center" justify="flex-start" gap={16}>
              <img
                src={Logo}
                height="28px"
                alt=""
                style={{ marginLeft: SIZES.xLarge }}
              />
              <Dropdown overlay={menu} trigger={["click"]}>
                <a onClick={(e) => e.preventDefault()}>
                  <Space>
                    <span
                      style={{
                        fontSize: 32,
                        paddingRight: 4,
                        color: colorBorder,
                        fontWeight: 100,
                      }}
                    >
                      |
                    </span>
                    <span>
                      {parseInt(companyId)
                        ? companyList.find(
                          (c) => c.value === parseInt(companyId)
                        )?.label
                        : "Select Company"}
                    </span>
                    <DownOutlined style={{ color: colorBorder }} />
                  </Space>
                </a>
              </Dropdown>
              {/* <img src={fileList[0]?.url} alt="User Profile" /> */}
            </Flex>
            <Flex align="center" justify="center" gap={12}>
              <Tooltip placement="left" title="Search Documents">
                <Button
                  type="text"
                  icon={<SearchOutlined />}
                  onClick={showDrawer}
                />
              </Tooltip>
              <Badge count={count} overflowCount={9} offset={[-2, 4]}>
                <Dropdown
                  menu={{
                    items,
                    onClick,
                  }}
                  trigger={["click"]}
                  visible={dropdownVisible} // Control visibility
                  onVisibleChange={handleVisibleChange} // Handle visibility changes
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <Avatar
                      style={{ backgroundColor: colorPrimary }}
                      src={fileList[0]?.url ? fileList[0]?.url : Empty_profile_pic}
                      size="large"
                    />
                    {/* <img s src={fileList[0]?.url || defaultImage} className="user-image" /> */}
                    {/* <img src="http://localhost:15000/profile-pictures/bfgSivw7piXUE3V4PPjjmJ.jpg" />
                                        <img src={fileList.url} /> */}
                  </a>
                </Dropdown>
              </Badge>
            </Flex>
          </Flex>
        </Header>
        <Content
          style={{
            minHeight: "calc(100svh - 64px)",
            overflowY: "auto",
            marginBottom: 64,
          }}
        >
          <Outlet />
        </Content>
        <Drawer title={documentSearchTitle} onClose={onClose} open={open}>
          <Search
            size="large"
            placeholder="Search"
            onSearch={onSearchHandler}
            value={searchText}
            onChange={(e) => searchTextonChange(e.target.value)}
            style={{
              marginBottom: 8,
            }}
          />
          {documentsLoading && <CommonSkeletonLoader />}
          {(documentSearchMessage && !documentsLoading) &&
            <Flex
              vertical
              align="center"
              justify="center"
              style={{ height: "calc(100% - 128px)" }}
            >

              <Empty
                description={
                  <Typography.Text>
                    {documentSearchMessage}
                  </Typography.Text>
                }
              />
            </Flex>}

          {/* {(!payload || (payload.length && !documentsLoading)) === 0 && (
            <Flex
              vertical
              align="center"
              justify="center"
              style={{ height: "calc(100% - 128px)" }}
            >
            </Flex>
            )} */}
          {!documentsLoading &&
            Array.from({ length: payload.length, payload }).map((_, index) => (
              <div
                style={{
                  marginBottom: 8,
                  padding: 12,
                  background: colorBgContainer,
                  borderRadius: borderRadiusLG,
                  border: `1px solid ${colorBorder}`,
                  cursor: "pointer",
                }}
              >
                <Flex
                  vertical
                  gap={4}
                  justify="flex-start"
                  align=""
                  style={{ width: "100%" }}
                  onClick={() => handlePDFAnnotation(payload[index])}
                >
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {payload[index].date} | {payload[index].time}
                  </Text>
                  <Text strong>{payload[index].documentName}</Text>
                  {/* <Flex justify="flex-start" align="center" gap={16}> */}
                  <Tag color="green">{payload[index].categoryName}</Tag>
                  <Tag>{payload[index].itemCode}</Tag>
                  {/* </Flex> */}
                </Flex>
              </div>
            ))}
          {/* use this pagination  */}
          {
            payload.length > 0 &&

            <Pagination
              align="center"
              current={pagination}
              pageSize={10}
              total={totalResults}
              onChange={paginationOnChangehHandler}
            />

          }

          {/* if nothing to show. use bellow */}
          {/* <Flex vertical align='center' justify='center' style={{height:'calc(100% - 128px)'}}>
                        <Empty />
                    </Flex> */}
        </Drawer>

        <Drawer
          title="Notifications"
          onClose={closeNotificationDrawer}
          open={openNotification}
        >
          {notifications.length > 0 && (
            <Flex justify="flex-end" align="center" gap="large" style={{ marginBottom: 12 }}>
              <Button onClick={clearAllNotifications} type="link" danger>
                Clear All
              </Button>
            </Flex>
          )}
          {
            notifications.length > 0 ? (
              notifications.map((notification) => (
                <div key={notification.id}
                  style={{
                    padding: 8,
                    background: colorBorderSecondary,
                    borderRadius: borderRadiusLG,
                    marginBottom: 8,

                  }}
                >
                  <Flex justify="space-between" align="center" gap={16}>
                    <Flex
                      justify="start-flex"
                      align="center"
                      gap={16}
                      style={{ alignItems: "baseline", background: colorNoContainer, width: '100%' }}
                    >
                      <Content style={{ minWidth: 0 }}>
                        <p style={{ marginBottom: "10px" }}>{notification?.title}</p>
                        <p style={{ marginBottom: "0px", fontSize: 16, overflowWrap: 'break-word' }}>{notification?.body}</p>
                        <span
                          style={{ fontSize: 12, lineBreak: "normal", width: "100%" }}
                        >{dayjs(notification.createdAt).fromNow()}</span>
                      </Content>

                      <CloseOutlined
                        onClick={() => handleNotificationClose(notification.id)}
                        style={{
                          fontSize: 14,
                          cursor: "pointer",
                          marginLeft: 8,
                          color: "#999",
                        }}
                      />
                    </Flex>
                  </Flex>
                </div>
              ))
            ) : (
              <Empty />
            )
          }
        </Drawer>

        {/* Annotation Modal */}
        <AnnotationModal
          visible={annotationModalVisible}
          annotationUrl={currentAnnotationUrl}
          onClose={() => {
            setAnnotationModalVisible(false);
            setCurrentAnnotationUrl(null);
            setCurrentAnnotationTitle("PDF Annotation");
          }}
          title={currentAnnotationTitle}
          height="95vh"
        />
      </Flex>
    </Layout>
  );
};
export default MainLayout;
